import { render, staticRenderFns } from "./TForm.vue?vue&type=template&id=1cdd2926"
import script from "./TForm.vue?vue&type=script&lang=js"
export * from "./TForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports